import { BASE_URL } from "../constants/constants";
import AuthUtils from "../auth/AuthUtils";
export class ContactTracingService {
  public async getContactTracingByCompanyId(companyId: String) {
    try {
      let response = await fetch(`${BASE_URL}/tracing/companies/${companyId}`, {
        method: "GET",
        headers: AuthUtils.getHeaders(),
        credentials: "include"
      });
      let ret = await response.json();
      if (!response.ok && ret && !ret.success) {
        return {
          error: ret.message,
          status: response.status,
          ok: response.ok
        };
      }
      return ret;
    } catch (e:any) {
      return {
        error: e.message,
        status: 500,
        ok: false
      };
    }
  }
}
